import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/render/project/src/node_modules/.pnpm/gatsby-theme-docz@2.3.1_@babel+core@7.11.1_@types+node@24.7.0_docz@2.4.0_@babel+core@7._04842b0c5656885ffb9b2f355e30df2b/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "lowkey-living-styleguide"
    }}>{`Lowkey Living Styleguide`}</h1>
    <p>{`A dev-only reference page showing the lowKey UI components (buttons, inputs,
selects, tables, modals, tooltips, field/rich-text views, etc.) as they
actually render in this app, so we can eyeball them in one place.`}</p>
    <h2 {...{
      "id": "viewing-it"
    }}>{`Viewing it`}</h2>
    <p>{`The styleguide is a `}<strong parentName="p">{`dev-only route`}</strong>{` (added only when `}<inlineCode parentName="p">{`import.meta.env.DEV`}</inlineCode>{`,
see `}<inlineCode parentName="p">{`app/src/routes.jsx`}</inlineCode>{`). With the dev server running, open:`}</p>
    <pre><code parentName="pre" {...{}}>{`https://local.kualibuild.com/styleguide        # inside the container
https://local.kualibuild.com:4001/styleguide    # from the host
`}</code></pre>
    <p>{`It is not built into production.`}</p>
    <h2 {...{
      "id": "structure"
    }}>{`Structure`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`index.jsx`}</inlineCode>{` — page entry; assembles the sections and sets the
`}<inlineCode parentName="li">{`data-styleguide-ready`}</inlineCode>{` flag once mounted.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`section.jsx`}</inlineCode>{` — shared section wrapper (heading + layout).`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`sections/*.jsx`}</inlineCode>{` — one file per component section (e.g. `}<inlineCode parentName="li">{`buttons.jsx`}</inlineCode>{`,
`}<inlineCode parentName="li">{`text-input.jsx`}</inlineCode>{`, `}<inlineCode parentName="li">{`select.jsx`}</inlineCode>{`, `}<inlineCode parentName="li">{`table.jsx`}</inlineCode>{`, `}<inlineCode parentName="li">{`modal.jsx`}</inlineCode>{`, `}<inlineCode parentName="li">{`tooltip.jsx`}</inlineCode>{`,
`}<inlineCode parentName="li">{`field-label.jsx`}</inlineCode>{`, `}<inlineCode parentName="li">{`rich-text-view.jsx`}</inlineCode>{`, …). Add a new section by creating a
file here and registering it in `}<inlineCode parentName="li">{`index.jsx`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "lowkey-componentshtml--the-static-snapshot"
    }}><inlineCode parentName="h2">{`lowkey-components.html`}</inlineCode>{` — the static snapshot`}</h2>
    <p><inlineCode parentName="p">{`lowkey-components.html`}</inlineCode>{` is a `}<strong parentName="p">{`generated, self-contained`}</strong>{` HTML snapshot of the
rendered `}<inlineCode parentName="p">{`/styleguide`}</inlineCode>{` page. It's committed so designers/devs can open the
component reference without running the app (and to diff visual changes over
time). Component styles are inlined; web fonts/images keep their origin URLs.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Do not hand-edit it`}</strong>{` and do not copy styles out of it — it's generated.`}</li>
      <li parentName="ul"><strong parentName="li">{`Source of truth`}</strong>{` for the styles is `}<inlineCode parentName="li">{`app/src/app.css`}</inlineCode>{` (the `}<inlineCode parentName="li">{`.lowkey`}</inlineCode>{` /
`}<inlineCode parentName="li">{`.lowkey-forms`}</inlineCode>{` blocks), `}<inlineCode parentName="li">{`app/src/ui/`}</inlineCode>{`, and `}<inlineCode parentName="li">{`tailwind.config.js`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`It is excluded from Prettier (see `}<inlineCode parentName="li">{`.prettierignore`}</inlineCode>{`) so it isn't reformatted.`}</li>
    </ul>
    <h3 {...{
      "id": "regenerating-the-snapshot"
    }}>{`Regenerating the snapshot`}</h3>
    <p>{`With the dev server running, from the `}<inlineCode parentName="p">{`builder-ui`}</inlineCode>{` repo root:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# inside an af container (chromium preinstalled)
node scripts/export-styleguide/index.mjs

# on a host with Google Chrome
PW_CHANNEL=chrome node scripts/export-styleguide/index.mjs https://local.kualibuild.com:4001/styleguide
`}</code></pre>
    <p>{`By default it writes back to this file
(`}<inlineCode parentName="p">{`app/src/pages-builder/styleguide/lowkey-components.html`}</inlineCode>{`). Pass a URL and/or
an output path as args to override. Login defaults to `}<inlineCode parentName="p">{`kualiadmin`}</inlineCode>{` / `}<inlineCode parentName="p">{`admin`}</inlineCode>{`
for local dev (override with `}<inlineCode parentName="p">{`KUALI_USER`}</inlineCode>{` / `}<inlineCode parentName="p">{`KUALI_PASS`}</inlineCode>{`). Commit the refreshed
snapshot alongside any component/style change so it stays current.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      